import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectClusterList } from '../../../store/slices/clusterListSlice'
import { ClusterInterface } from '../../../common/types/interfaces'
import classes from './OrderStats.module.sass'
import { OrderStatsItem } from './orderStatsItem/OrderStatsItem'

export const OrderStats = () => {
  const clusters = useSelector(selectClusterList) as ClusterInterface[]
  const [activeId, setActiveId] = useState<number | 'all'>('all')

  useEffect(() => {
    if (clusters.length && activeId === 'all') setActiveId(clusters[0].id!)
  }, [clusters])

  if (!clusters.length) return null

  const currentId = activeId === 'all' && clusters[0]?.id ? clusters[0].id : activeId
  const visible = currentId === 'all' ? clusters : clusters.filter((c) => c.id === currentId)

  return (
    <div className={classes.wrapper}>
      {clusters.length > 1 && (
        <div className={classes.tabs}>
          {clusters.map((c) => (
            <button
              key={c.id}
              className={`${classes.tab} ${currentId === c.id ? classes.active : ''}`}
              onClick={() => setActiveId(c.id!)}
            >
              {c.name}
            </button>
          ))}
        </div>
      )}

      <div className={classes.list}>
        {visible.map((cluster) => (
          <OrderStatsItem key={cluster.id} cluster={cluster} />
        ))}
      </div>
    </div>
  )
}
